import { useMemo } from 'react';

import { useStore } from '@/src/store';
import { useForexStore } from '@clubpay/payment-kit';
import { Typography } from '@mui/material';
import Symbol from '@qlub-dev/qlub-kit/dist/components/Symbol';

import styles from './styles.module.scss';

type Props = {
  variant: 'currency' | 'currency-mini' | 'title_lg';
  color?: string;
  ignoreForex?: boolean;
  currencyOverride?: string;
};

const Currency = ({
  variant,
  color,
  ignoreForex = false,
  currencyOverride,
}: Props) => {
  const initialLink = useStore(state => state.initialLink);
  const forex = useForexStore();

  const currency = useMemo(() => {
    if (currencyOverride) return currencyOverride.toUpperCase();
    if (!ignoreForex && forex?.isApplied) {
      return (forex.currencyCode || '').toUpperCase();
    }
    return (initialLink?.data.currency || '').toUpperCase();
  }, [forex.isApplied, forex?.currencyCode, initialLink?.data.currency]);

  if (currency)
    return (
      <Typography
        variant={variant === 'title_lg' ? 'title_lg' : 'currency'}
        color={color}
      >
        <div
          className={
            variant === 'currency-mini'
              ? styles['icon-currency-mini']
              : variant === 'title_lg'
              ? styles['icon-title-lg']
              : ''
          }
        >
          {Symbol(currency, { replace: true })}
        </div>
      </Typography>
    );
};

export default Currency;
